'use client';
import React from 'react';
import { Anchor } from '../Anchor';
import { classNames } from '../../utils/classNames';

export interface ProductCardProps {
  selected: boolean;
  productUrl?: string;
  dark?: boolean;
  onSelect?: () => void;
  children: React.ReactNode;
}

const ProductCard = ({ selected, productUrl, dark, onSelect, children }: ProductCardProps) => (
  <li
    aria-current={selected ? 'true' : 'false'}
    role="group"
    aria-label="product"
    className={classNames(
      'bg-white w-full items-center',
      selected && 'border-4 border-brand-300',
      !dark && !selected && 'border-2 border-neutral-200',
    )}
  >
    {!selected ? (
      <Anchor link={productUrl} onClick={onSelect}>
        {children}
      </Anchor>
    ) : (
      children
    )}
  </li>
);

export default ProductCard;
